export default __webpack_public_path__ + "static/media/Webinar-MATES-ED2MIT-\"Introduction-to-Big-Data-and-Data-Management-for-Maritime-Industry\".3d819cc6.md";